module.exports = __webpack_public_path__ + "static/media/10.774b79fc.png";